module.exports = __webpack_public_path__ + "static/media/GW.19e1492c.svg";